import React from "react";
import moment from "moment";
import { Calendar } from "lucide-react";
import { UserAuth } from "../../context/AuthContext";

const titleCase = (str) =>
  str
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");

const deriveDisplayName = (user) => {
  if (user?.given_name) return user.given_name;
  if (user?.name) return user.name;
  if (user?.email) {
    const local = user.email.split("@")[0];
    return titleCase(local);
  }
  return "there";
};

const WelcomeBanner = () => {
  const { user } = UserAuth();
  const displayName = deriveDisplayName(user);
  const primaryRole = user?.isAdmin
    ? "Admin"
    : user?.roles?.[0] || null;

  return (
    <div className="welcome-banner">
      <div className="welcome-banner__content">
        <div className="welcome-banner__text">
          <div className="welcome-greeting">Welcome back</div>
          <h1 className="welcome-title">
            {displayName}
            {primaryRole && (
              <span className="welcome-role-chip">{primaryRole}</span>
            )}
          </h1>
        </div>
        <div className="welcome-date">
          <Calendar size={14} strokeWidth={1.75} />
          <span>{moment().format("dddd, MMMM Do YYYY")}</span>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;
